// The restaurant's chats in the platform agent's panel (D4). Wording from the Amigo design's copy sheet (Chats, Chats
// none); `status` are the chat statuses of docs/platform-agent/contracts.md §6, `who.kinds` who started a chat.
export default {
  title: 'Discussions',
  new_chat: 'Nouvelle discussion',
  note: {
    team: 'Toutes les discussions sur {{restaurant}} : les vôtres, celles de votre équipe et celles du restaurant.',
    own: 'Vos discussions sur {{restaurant}}.',
    // No restaurant selected (D18): the person's own chats started that way.
    no_restaurant:
      "Vos chats sans restaurant sélectionné. Un chat passe dans les chats d'un restaurant dès que vous le sélectionnez.",
  },
  log: 'Toutes les demandes dans le journal Amigo',
  days: {
    today: "Aujourd'hui",
    yesterday: 'Hier',
    earlier: 'Plus ancien',
  },
  who: {
    you: 'Vous',
    kinds: {
      foodamigos: 'FoodAmigos',
      owner: 'Propriétaire',
      staff: 'Équipe',
      partner: 'Partenaire',
    },
  },
  status: {
    done: 'Terminé',
    answered: 'Répondu',
    waiting: "En attente d'approbation",
    partial: '{{applied}} sur {{total}} appliquées',
    rejected: 'Refusé',
    not_yet: 'Pas encore possible',
    failed: 'Échec',
  },
  none: {
    title: 'Aucune discussion pour {{restaurant}}',
    title_no_restaurant: "Aucun chat pour l'instant sans restaurant sélectionné",
    text: 'Les discussions démarrées ici restent ici, vous pouvez donc y revenir.',
  },
  loading: 'Chargement des discussions…',
  loading_more: "Chargement d'autres discussions…",
  load_failed: 'Impossible de charger les discussions.',
  retry: 'Réessayer',
  // A chat with answers the person hasn't read (QA45), before its last line.
  new_answers_one: 'Nouvelle réponse :',
  new_answers_other: 'Nouvelles réponses :',
};
